export default "__VITE_ASSET__wuZc8y8V__"